module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-700-477.b628845.woff2";